import React, {useState} from "react";
import {View, TouchableOpacity, StyleSheet} from "react-native";
import { useDispatch, useSelector } from "react-redux";
import {logIn, loginICPM} from "../auth-service/auth-service";
import {styleVars} from "../../../app-style-vars";
import PtText from "../pt-text/pt-text";
import {getTranslation} from "../../../helpers/getTranslation";
import {getSubdomain} from "../../../helpers/getSubdomain";
const featuresCache = () => {return require('../../../assets/countryConfigs.json')}
const getCountryFeatures = (featuresObject: any, country: string) => {
  const availableFeatures:any = [];
  console.log('----------- the available features = ', featuresObject, ' --- country = ', country);
  Object.keys(featuresObject).forEach((featureKey) => {
    if(featuresObject[featureKey][country.toLowerCase()]) {
      console.log('----------- the available features = ', featuresObject, ' --- country = ', country);
      availableFeatures.push(featureKey);
    }
  })
  return availableFeatures;
}
export default function Login(props:any) {
  const loginLabelIcpm = props.loginLabelIcpm || getTranslation('login.label.icpm') || 'Login';
  const loginLabelSso = props.loginLabelSso || getTranslation('login.label.sso') || 'Bosch Login'
  const dispatch = useDispatch();
  const isAuthenticated: any = useSelector((state: any) => state.authReducer.isAuthenticated);

  const [loginInProgress, setLoginInProgress] = useState(false);

  const doLogin = async () => {
    setLoginInProgress(true);
    logIn(dispatch).then((resp) => {
      setLoginInProgress(resp);
    });
  }
  const doLoginInternal = async () => {
    setLoginInProgress(true);
    loginICPM(dispatch, true).then((resp) => {
      setLoginInProgress(resp);
    });
  }
  const doLoginExternal = async () => {
    setLoginInProgress(true)
    loginICPM(dispatch, false).then((resp) => {
      setLoginInProgress(resp)
    })
  }
  return (
    <>
          <View>
            {!isAuthenticated && !loginInProgress ?
                <View>
                  <TouchableOpacity onPress={doLoginExternal} style={styles.loginButtonContainer}>
                    <PtText style={styles.loginButtonText}>
                      {loginLabelIcpm}
                    </PtText>
                  </TouchableOpacity>
                  <TouchableOpacity onPress={doLoginInternal} style={styles.loginButtonContainer}>
                    <PtText style={styles.loginButtonText}>
                      {loginLabelSso}
                    </PtText>
                  </TouchableOpacity>
                </View>
                :
                <View>
                  <View style={[styles.loginButtonContainer, styles.loginButtonDisabled]}>
                    <PtText style={[styles.loginButtonText, {color: styleVars.boschDarkGray}]}>
                      {loginLabelIcpm}
                    </PtText>
                  </View>
                  <View style={[styles.loginButtonContainer, styles.loginButtonDisabled]}>
                    <PtText style={[styles.loginButtonText, {color: styleVars.boschDarkGray}]}>
                      {loginLabelSso}
                    </PtText>
                  </View>
                </View>
            }
          </View>
    </>
  )

}

const styles = StyleSheet.create({
  loginButtonContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginVertical: styleVars.rem(.5),
    marginHorizontal: styleVars.rem(.5),
    backgroundColor: styleVars.boschDarkBlue,
    justifyContent: 'center',
    alignItems: 'center'
  },
  loginButtonDisabled: {
    backgroundColor: styleVars.boschLightGray,
  },
  loginButtonText: {
    fontSize: styleVars.rem(.875),
    color: '#fff',
  },
});
